import {ErrorType} from '~/enums/ErrorType'
import NavigableValidator from '~/models/navigableValidators/navigableValidator'
import ValidationError from '~/models/validationError'
import {ProcessFlowTakeActionStep} from '~/models/processFlows/steps/processFlowTakeActionStep'
import {ProcessFlowGenerateDocumentV2Step} from "~/models/processFlows/steps/processFlowGenerateDocumentV2Step"

export default class ProcessFlowGenerateDocumentV2StepValidator extends NavigableValidator<ProcessFlowTakeActionStep> {
  _validatorKey = 'step';
  defaultType = ErrorType.mustBePresent;

  _validate(model: ProcessFlowGenerateDocumentV2Step): void {
    if (!model.hasValidSource) {
      this.errors.push(this.buildValidationError(model, 'Source not configured'))
    }
    if (!model.hasValidDestination) {
      this.errors.push(this.buildValidationError(model, 'Destination not configured'))
    }
  }

  buildValidationError(model: ProcessFlowGenerateDocumentV2Step, value?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: model.titleOrDefault,
      errorNavOpts: model.validation.errorNavOpts(this, 'step', model),
      type: type || this.defaultType,
      section: this.section,
    });
  }
}